import { css } from '@emotion/css';
import React from 'react';
import { ReactComponent as ReportedProfile } from '../../assets/images/reported_profile.svg';
import { FadeInImage } from './FadeInImage';

interface CharacterImageProps {
  src?: string;
  imageId?: string;
  imageAriaLabel?: string;
  ariaHidden?: boolean;
  isPlayer?: boolean;
  isReported?: boolean;
  withBorder?: boolean;
  borderWidth?: number;
  backgroundColor?: string;
}

export const CharacterImage: React.FC<CharacterImageProps> = ({
  src,
  imageId,
  imageAriaLabel,
  ariaHidden,
  isPlayer,
  isReported,
  withBorder,
  borderWidth,
  backgroundColor
}) => {
  if (isReported) {
    return <ReportedProfile aria-hidden={true} />;
  } else {
    return src ? (
      <div
        className={css`
          border: ${withBorder ? `${borderWidth ?? 4}px solid #faf7da` : 'inherit'};
          border-radius: 50%;
          background: ${backgroundColor ?? '#e6dfc2'};
          width: 100%;
          height: 100%;
          overflow: ${isPlayer ? 'hidden' : 'inherit'};
          transform: translateZ(0);
          /* Workaround for Safari https://forum.webflow.com/t/safari-not-hiding-overflow-on-rounded-corner-divs/55060 */
          mask-image: ${isPlayer ? 'radial-gradient(white, black)' : 'none'};
        `}
      >
        <FadeInImage
          src={src}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            borderRadius: isPlayer ? '50%' : 'unset'
          }}
          imgId={imageId}
          ariaLabel={imageAriaLabel}
          ariaHidden={ariaHidden}
        />
      </div>
    ) : (
      <></>
    );
  }
};
